import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
useEffect(() => {
window.scrollTo(0, 0);
}, []);

return (
<>
{/* Breadcrumbs */} <section className="breadcrumbs"> <div className="container"> <ol> <li><Link to="/">Home</Link></li> <li>Privacy Policy</li> </ol> <h2>Privacy Policy</h2> </div> </section>

  <section className="about-page">
    <div className="container">

      <div className="content mb-5">
        <h3>Privacy Policy</h3>
        <p>
          Last Updated: May 2026
        </p>

        <p>
          SDtech Solutions respects your privacy and is committed to
          protecting your personal information. This Privacy Policy
          explains how we collect, use, store, and safeguard your data
          when you use our applications, websites, and services.
        </p>
      </div>

      <div className="row gy-4">

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>Information We Collect</h4>
            <p>
              We may collect user information such as name, email address,
              profile information, attendance records, uploaded images,
              and other information necessary for application functionality.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>Camera Access</h4>
            <p>
              Our attendance applications may use your device camera for
              attendance verification, profile photos, and identity
              confirmation purposes. Camera access is only used when
              required by the application.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>How We Use Data</h4>
            <p>
              Collected information is used to provide attendance
              management, authentication, reporting, account management,
              customer support, and service improvements.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>Data Storage & Security</h4>
            <p>
              User data is securely stored using trusted cloud services
              including Firebase infrastructure. We implement reasonable
              security measures to protect data against unauthorized access.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>Third-Party Services</h4>
            <p>
              Our applications may use third-party services such as
              Firebase Authentication, Firestore Database, Cloud Storage,
              and analytics services to provide functionality and improve
              performance.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="box p-4 shadow-sm rounded">
            <h4>User Rights</h4>
            <p>
              Users may request access, correction, or deletion of their
              personal information by contacting us through the details
              provided below.
            </p>
          </div>
        </div>

      </div>

      <div
        className="box mt-5"
        style={{
          background: "#f8f9fa",
          padding: "30px",
          borderRadius: "10px"
        }}
      >
        <h3>Contact Us</h3>

        <p>
          If you have any questions regarding this Privacy Policy,
          please contact us:
        </p>

        <p>
          <strong>SDtech Solutions</strong><br />
          Email: info.sdtechsolutions@gmail.com<br />
          Website: https://sdtechsolutionsorg.com
        </p>
      </div>

    </div>
  </section>
</>

);
}
